import { Typography } from '@mui/material'

import { useStyles } from './Mock.styles'

export interface MockProps {
  route: string
}

export const Mock = ({ route }: MockProps) => {
  const { classes } = useStyles()

  return (
    <div data-testid='mock'>
      <div className={classes.mock}>
        <Typography variant='subtitle1'>You are currently on</Typography>
        <Typography variant='h4'>the {route} page.</Typography>
        <Typography>{`Nice work, you`}</Typography>
      </div>
    </div>
  )
}
